import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

export default function AboutPage() {
  const values = [
    {
      icon: 'ri-shield-check-line',
      title: 'Integrity',
      description: 'We uphold the highest ethical standards in all our operations and interactions.'
    },
    {
      icon: 'ri-eye-line',
      title: 'Transparency',
      description: 'Clear communication and honest dealings form the foundation of our relationships.'
    },
    {
      icon: 'ri-hand-heart-line',
      title: 'Responsibility',
      description: 'We practice responsible lending and prioritize the financial wellbeing of our clients.'
    },
    {
      icon: 'ri-group-line',
      title: 'Financial Inclusion',
      description: 'Committed to providing accessible financial services to underserved communities.'
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      <Navbar />

      {/* Hero Banner */}
      <section className="pt-32 pb-16 px-4 sm:px-6 lg:px-8 bg-[#1A3A52]">
        <div className="max-w-4xl mx-auto text-center">
          <nav className="text-sm text-white/60 mb-4">
            <span>Home</span> <span className="mx-2">/</span> <span className="text-white">About Us</span>
          </nav>
          <h1 className="text-4xl md:text-5xl font-bold text-white">
            About Nakhalat Finance
          </h1>
        </div>
      </section>

      {/* Company Overview */}
      <section className="py-20 px-4 sm:px-6 lg:px-8 bg-white">
        <div className="max-w-4xl mx-auto">
          <div className="prose prose-lg max-w-none">
            <p className="text-lg text-gray-700 leading-relaxed mb-6">
              Nakhalat Finance (Private) Limited is a Zimbabwean-registered microfinance institution, fully licensed and regulated by the Reserve Bank of Zimbabwe. We are dedicated to providing accessible, affordable, and responsible financial services to individuals and small businesses across the nation.
            </p>
            <p className="text-lg text-gray-700 leading-relaxed mb-6">
              Since our establishment, we have been committed to bridging the financial gap for underserved communities, empowering entrepreneurs, and supporting economic growth through transparent and ethical lending practices.
            </p>
            <p className="text-lg text-gray-700 leading-relaxed">
              Our approach combines regulatory compliance with a deep understanding of local market needs, ensuring that every loan we provide contributes to sustainable financial inclusion and economic development in Zimbabwe.
            </p>
          </div>
        </div>
      </section>

      {/* Vision & Mission */}
      <section className="py-20 px-4 sm:px-6 lg:px-8 bg-[#E8EFF5]">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {/* Vision */}
            <div className="bg-white rounded-xl p-8 shadow-sm">
              <div className="w-14 h-14 flex items-center justify-center bg-[#1A3A52] rounded-lg mb-6">
                <i className="ri-eye-line text-2xl text-white"></i>
              </div>
              <h2 className="text-2xl font-bold text-[#1A3A52] mb-4">Our Vision</h2>
              <p className="text-gray-700 leading-relaxed">
                To be Zimbabwe's most trusted microfinance partner, driving sustainable economic growth and financial inclusion across all communities.
              </p>
            </div>

            {/* Mission */}
            <div className="bg-white rounded-xl p-8 shadow-sm">
              <div className="w-14 h-14 flex items-center justify-center bg-[#1A3A52] rounded-lg mb-6">
                <i className="ri-compass-line text-2xl text-white"></i>
              </div>
              <h2 className="text-2xl font-bold text-[#1A3A52] mb-4">Our Mission</h2>
              <p className="text-gray-700 leading-relaxed">
                To provide accessible, affordable, and responsible financial services that empower individuals and businesses to achieve their goals while maintaining the highest standards of integrity and transparency.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Values Grid */}
      <section className="py-20 px-4 sm:px-6 lg:px-8 bg-white">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold text-[#1A3A52] mb-4">
              Our Core Values
            </h2>
            <p className="text-lg text-gray-600">
              The principles that guide everything we do
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            {values.map((value, index) => (
              <div 
                key={index}
                className="bg-white rounded-xl p-6 border border-gray-200 hover:shadow-lg transition-all duration-300"
              >
                <div className="w-14 h-14 flex items-center justify-center bg-[#E8EFF5] rounded-lg mb-4">
                  <i className={`${value.icon} text-2xl text-[#1A3A52]`}></i>
                </div>
                <h3 className="text-xl font-bold text-[#1A3A52] mb-3">
                  {value.title}
                </h3>
                <p className="text-sm text-gray-600 leading-relaxed">
                  {value.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Governance Statement */}
      <section className="py-20 px-4 sm:px-6 lg:px-8 bg-[#E8EFF5]">
        <div className="max-w-4xl mx-auto">
          <div className="bg-white rounded-xl p-8 md:p-12 shadow-sm">
            <h2 className="text-3xl font-bold text-[#1A3A52] mb-6">
              Governance & Ethics
            </h2>
            <div className="space-y-4 text-gray-700 leading-relaxed">
              <p>
                Nakhalat Finance operates under a robust governance framework that ensures accountability, transparency, and ethical conduct at all levels of our organization. Our board of directors and management team are committed to upholding the highest standards of corporate governance.
              </p>
              <p>
                We maintain strict compliance with all regulatory requirements set forth by the Reserve Bank of Zimbabwe and adhere to international best practices in microfinance operations. Our internal controls, risk management systems, and audit processes are designed to protect the interests of our clients, stakeholders, and the broader financial system.
              </p>
              <p>
                Regular training, clear policies, and a culture of integrity ensure that every member of our team understands and upholds our commitment to ethical lending, customer protection, and responsible financial services.
              </p>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}